import { getShowBalanceButton } from 'redesign/components/templates/absence-request-details/utils/office/get-show-balance-button'
import type { Action } from '../action-wrapper/types'
import type { GetAbsenceAcceptActionButtonsProps } from './types'

export const getActionButtons = ({ onSubmit, t, showBalance }: GetAbsenceAcceptActionButtonsProps): Action[] => {
  return [
    {
      label: t('common.confirm'),
      testId: 'absence-request_detail-form-accept',
      onClick: onSubmit,
      variant: 'contained',
      color: 'primary',
    },
    getShowBalanceButton({
      t,
      openBalanceDrawer: showBalance,
      balanceDisabled: false,
    }),
  ]
}
